import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import LoadingIndicator from '~shared/components/react/LoadingIndicator';
import Banners from '~spa/Components/Banners';
import MadeForYouWidget from '~scenes/madeforyou/widget';
import InplayWidget from '~scenes/inplaywidget';
import RacingWidget from '~scenes/racingwidget/app';
import BetFeedWidget from '~scenes/betfeed/widget';
import PopularWidget from '~scenes/popularwidget';
import SportsWidget from '~shared/components/react/SportsWidget';
import CarouselIcons from '~spa/Components/CarouselIcons';
import XsellWidget from '~spa/Components/XsellWidget';
import PokerBlastWidget from '~spa/Components/PokerBlastWidget';
import OddsBoostWidget from '~spa/Components/OddsBoost/Widget';
import GolfWidget from '~spa/Components/GolfWidget';
import SpotlightWidget from '~scenes/SpotlightWidget/FullSpotlightWidget';
import LongArticleWidget from '~scenes/LongArticleWidget';

import { useFavouriteSports } from '~SpectateStore/hooks/userHooks';
import { useIsPokerBlastAvailable } from '~SpectateStore/hooks/pokerBlastHooks';
import { isGenericSport } from '~spa/Pages/SportGeneric/utils';
import { reorderWidgets } from '~spa/Pages/Homepage/utils';
import { useHomepageService } from '~spa/Pages/Homepage/service';

import {
    BANNERS_WIDGET,
    HORSE_RACING_WIDGET,
    GREYHOUND_RACING_WIDGET,
    CAROUSEL_WIDGET,
    BETFEED_WIDGET,
    POPULAR_WIDGET,
    INPLAY_WIDGET,
    TROTTING_WIDGET,
    HOMEPAGE_LOCATION,
    ODDS_BOOST_WIDGET,
    XSELL_WIDGET,
    POKER_BLAST_WIDGET,
    SPOTLIGHT_WIDGET,
    MADE_FOR_YOU_WIDGET,
    GOLF_SPORT_WIDGET,
    ARTICLE_WIDGET,
} from './constants';


const HomepageEntrypoint = () => {
    const widgets = useHomepageService();

    if (widgets === null) {
        return <LoadingIndicator />;
    }

    return <Homepage widgets={widgets} />;
};

HomepageEntrypoint.propTypes = {
    widgets: PropTypes.object,
};

const Homepage = ({widgets}) => {
    const favouriteSportIds = useFavouriteSports();
    const [widgetsOrder, setWidgetOrder] = useState([]);
    const [favouriteSportsWidgets, setFavouriteSportsWidgets] = useState([]);
    const isPokerBlastAvailable = useIsPokerBlastAvailable();

    const updateOrder = () => {
        const {
            widgetOrder,
            favouriteWidgets,
        } = reorderWidgets(widgets, favouriteSportIds);
        setWidgetOrder(widgetOrder);
        setFavouriteSportsWidgets(favouriteWidgets);
    };

    useEffect(() => {
        updateOrder();
    }, [favouriteSportIds]);

    return (
        <>
            {
                widgetsOrder.map((widget) => {
                    const isFavouriteSport = favouriteSportsWidgets.includes(widget);
                    switch (widget) {
                        case BANNERS_WIDGET:
                            return <Banners key={widget} />;

                        case HORSE_RACING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'horse-racing'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case GREYHOUND_RACING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'greyhound-racing'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case TROTTING_WIDGET:
                            return <RacingWidget key={widget} widgetType={'trotting'} showHeader={true} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case CAROUSEL_WIDGET:
                            return <CarouselIcons key={widget} source={HOMEPAGE_LOCATION} />;

                        case BETFEED_WIDGET:
                            return <BetFeedWidget key={widget} />;

                        case POPULAR_WIDGET:
                            return <PopularWidget key={widget} source={HOMEPAGE_LOCATION} />;

                        case INPLAY_WIDGET:
                            return <InplayWidget key={widget} isShowFooter={true} source={HOMEPAGE_LOCATION}/>;

                        case MADE_FOR_YOU_WIDGET:

                            return <MadeForYouWidget key={widget} />;
                        case ODDS_BOOST_WIDGET:
                            return <OddsBoostWidget key={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport} />;

                        case XSELL_WIDGET:
                            return <XsellWidget key={widget}/>;

                        case GOLF_SPORT_WIDGET:
                            return <GolfWidget key={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport}/>;

                        case POKER_BLAST_WIDGET:
                            if (!isPokerBlastAvailable) {
                                return null;
                            }

                            return <PokerBlastWidget key={widget}/>;

                        case SPOTLIGHT_WIDGET:
                            return <SpotlightWidget key={widget} betLocate="homepage" />;

                        case ARTICLE_WIDGET:
                            return <LongArticleWidget key={widget} gtmAction='Longform-Article' />;
                        default:
                            if (isGenericSport(widget)) {

                                return <SportsWidget key={widget} sport={widget} source={HOMEPAGE_LOCATION} isFavouriteSport={isFavouriteSport} />;
                            }

                            return null;
                    }
                })
            }
        </>
    );
};

Homepage.propTypes = {
    widgets: PropTypes.object,
};

export default HomepageEntrypoint;
